import React from "react";
import "./style.scss";

export default function FullScreenLoader() {
  return (
    <div className="fullscreen-loader" aria-live="polite" aria-busy="true">
      <div className="spinner" />
      <div className="loading-text">Đang tải...</div>
    </div>
  );
}

